import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-settings-menu" }
const _hoisted_2 = { class: "user-settings-list" }
const _hoisted_3 = ["href", "data-heap"]
const _hoisted_4 = { class: "logout" }
const _hoisted_5 = {
  action: "/logout",
  method: "post"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value", "data-heap"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "headline"
}
const _hoisted_10 = {
  key: 1,
  class: "headline"
}
const _hoisted_11 = {
  key: 2,
  class: "menu-item freelance-cta"
}
const _hoisted_12 = ["href", "data-heap"]
const _hoisted_13 = {
  key: 3,
  class: "menu-item freelance-cta"
}

import {PrismicRichText} from '@prismicio/vue';
    import {ref, onMounted} from 'vue';
    import {UserSettingsSliceSlice} from '@/unlogged/prismicio';
    import {UserData} from '@/unlogged/types/custom';
    import {ServerSideNavigationPrismicLink, usePrismicFieldHelpers, useTypeGuards, useUserInfoHelpers} from '@malt/vue-prismic';
    import {useCookies} from '@malt/vue3-use';

    type Props = {
        slice: UserSettingsSliceSlice;
        userData: UserData;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'UserSettingsControls',
  props: {
    slice: null,
    userData: null
  },
  setup(__props: any) {

    

    const {isFilledKeyText} = useTypeGuards();
    const {hasText} = usePrismicFieldHelpers();
    const {isCompany, isUserInfo} = useUserInfoHelpers();

    const xsrfToken = ref();

    onMounted(() => {
        const {XSRFTOKEN} = useCookies(['XSRF-TOKEN']);
        xsrfToken.value = XSRFTOKEN;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slice.items.filter((item) =>
                    __props.userData && __props.userData.info !== null && _unref(isCompany)(__props.userData.info)
                        ? item.visibleFor === 'companies'
                        : item.visibleFor === 'freelances',
                ), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_unref(isFilledKeyText)(item.linkText) && _unref(isFilledKeyText)(item.link))
            ? (_openBlock(), _createElementBlock("li", {
                key: `link-${index}`,
                class: "menu-item"
              }, [
                _createElementVNode("a", {
                  href: item.link,
                  "data-heap": item.heapId
                }, _toDisplayString(item.linkText), 9, _hoisted_3)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256)),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("input", {
            name: "_csrf",
            type: "hidden",
            value: xsrfToken.value
          }, null, 8, _hoisted_6),
          _createElementVNode("input", {
            class: "cta-item",
            type: "submit",
            value: __props.slice.primary.logOutText,
            "data-heap": __props.slice.primary.logOutHeapId
          }, null, 8, _hoisted_7)
        ])
      ]),
      _hoisted_8,
      (
                    __props.userData &&
                    _unref(isUserInfo)(__props.userData.info) &&
                    !_unref(isCompany)(__props.userData.info) &&
                    __props.slice.primary.createFreelanceAccountTitle &&
                    _unref(hasText)(__props.slice.primary.createFreelanceAccountTitle[0])
                )
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _createVNode(_unref(PrismicRichText), {
              field: __props.slice.primary.createFreelanceAccountTitle
            }, null, 8, ["field"])
          ]))
        : (
                    __props.userData &&
                    _unref(isUserInfo)(__props.userData.info) &&
                    _unref(isCompany)(__props.userData.info) &&
                    __props.slice.primary.submitProjectTitle &&
                    _unref(hasText)(__props.slice.primary.submitProjectTitle[0])
                )
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createVNode(_unref(PrismicRichText), {
                field: __props.slice.primary.submitProjectTitle
              }, null, 8, ["field"])
            ]))
          : _createCommentVNode("", true),
      (
                    __props.userData &&
                    _unref(isUserInfo)(__props.userData.info) &&
                    !_unref(isCompany)(__props.userData.info) &&
                    _unref(isFilledKeyText)(__props.slice.primary.createFreelanceText) &&
                    _unref(isFilledKeyText)(__props.slice.primary.createFreelanceLink)
                )
        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
            _createElementVNode("a", {
              href: __props.slice.primary.createFreelanceLink,
              "data-heap": __props.slice.primary.createFreelanceHeapId
            }, _toDisplayString(__props.slice.primary.createFreelanceText), 9, _hoisted_12)
          ]))
        : (
                    __props.userData &&
                    _unref(isUserInfo)(__props.userData.info) &&
                    _unref(isCompany)(__props.userData.info) &&
                    _unref(isFilledKeyText)(__props.slice.primary.submitProjectText) &&
                    _unref(isFilledKeyText)(__props.slice.primary.submitProjectLink)
                )
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createVNode(_unref(ServerSideNavigationPrismicLink), {
                field: __props.slice.primary.submitProjectLink,
                "data-heap": __props.slice.primary.submitProjectHeapId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.slice.primary.submitProjectText), 1)
                ]),
                _: 1
              }, 8, ["field", "data-heap"])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})